import React from 'react';

/**
 * Regras da coluna "Contexto (até 72h)".
 *
 * Ausente quando o paciente não teve atendimento anterior em até 72h. 
 * A montagem do texto e da faixa do badge fica em FormatHelpers; aqui ficam as regras de cor.
*/

/** Faixa da coluna Probabilidade: até 25% estável, até 50% atenção, acima disso alta. */
export const nivelProbabilidade = (previsaointernacao) => {
  const probabilidade = Number(previsaointernacao) || 0;
  if (probabilidade <= 25) return 'estavel';
  if (probabilidade <= 50) return 'atencao';
  return 'alta';
};

/**
 * Marcador à esquerda da linha: atendimento anterior em até 72h é sempre prioridade
 * alta; sem atendimento anterior, segue a faixa da probabilidade.
 * Retorna a classe de status já usada pela tabela (.canceled/.waiting/.scheduled).
 */
export const classeMarcador = (paciente) => {
  const nivel = paciente.contexto ? 'alta' : nivelProbabilidade(paciente.previsaointernacao);
  if (nivel === 'alta') return 'canceled';
  if (nivel === 'atencao') return 'waiting';
  return 'scheduled';
};
